import React, { useContext } from "react"
import { Div, Text } from "atomize"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faLocationDot, faRightToBracket } from "@fortawesome/free-solid-svg-icons"
import { motion } from "framer-motion"
import Card from "../atoms/Card"
import { theme } from "../settings/config"
import { modalContext } from "../providers/modal.provider"

// Un maestro senza nessun circolo. Ci si arriva uscendo dall'ultimo, o
// perché chi lo gestiva ce l'ha tolto: in entrambi i casi l'app non ha
// niente da mostrargli, e dirglielo è meglio che lasciarlo davanti a
// schermate vuote senza spiegazioni.
function NoSchoolCard() {
	const Modal = useContext(modalContext)

	const choices = [
		{
			id: "join",
			icon: faRightToBracket,
			title: "Ho il codice di un circolo",
			hint: "Te l'ha dato chi lo gestisce: entri e trovi tutto già pronto.",
			action: () => Modal.open("joinSchool"),
		},
		{
			id: "create",
			icon: faLocationDot,
			title: "Creo il mio circolo",
			hint: "Dove insegni, i campi, quanto fai pagare. Sono cose tue.",
			action: () => Modal.open("newSchool"),
		},
	]

	return (
		<Card bg={theme.colors.surface}>
			<Text textWeight="bold" textSize="subheader" m={{ b: "0.25rem" }}>
				Non sei in nessun circolo
			</Text>
			<Text textSize="caption" textColor={theme.colors.text_light} m={{ b: "1rem" }}>
				Le lezioni si segnano dentro un circolo: finché non ne hai uno non c'è molto da
				vedere. Quello che avevi scritto altrove non si è perso.
			</Text>

			<Div d="flex" flexDir="column" style={{ gap: "0.75rem" }}>
				{choices.map(choice => (
					<motion.div key={choice.id} whileTap={{ scale: 0.99 }}>
						<Div
							p="1rem"
							rounded="12px"
							cursor="pointer"
							d="flex"
							align="center"
							border="2px solid"
							borderColor={theme.colors.gray_light}
							style={{ gap: "0.75rem" }}
							onClick={choice.action}>
							<FontAwesomeIcon icon={choice.icon} color={theme.colors.primary} />
							<Div>
								<Text textSize="subheader" textWeight="bold">
									{choice.title}
								</Text>
								<Text textSize="caption" textColor={theme.colors.text_light}>
									{choice.hint}
								</Text>
							</Div>
						</Div>
					</motion.div>
				))}
			</Div>
		</Card>
	)
}

export default NoSchoolCard
